import './upload_or_choose_from_media_library_modal.less';

import React from 'react';

import Button from 'zoomforth_component_lib/btn_basic.jsx';
import SimpleModalWithHeader from 'zoomforth_component_lib/simple_modal_with_header.jsx';
import {
  CloudUploadIcon,
  ImageIcon
} from 'zoomforth_component_lib/app_modern_icons.jsx';

const UploadOrChooseFromMediaLibraryModal = ({
  show,
  title,
  subtitle,
  uploadFileText,
  selectFromMediaLibraryText,
  shouldShowMediaLibrarySelectionOption,
  onRequestClose,
  onUploadClick,
  onSelectFromMediaLibraryClick,
  ...rest
})=> (
  <SimpleModalWithHeader
    className="confirm-upload-or-choose-media-modal"
    show={show} 
    onRequestClose={onRequestClose}
    closeOnOuterClick={true}
    style={{ width: 500 }}
    title={title}
    subtitle={subtitle}
    {...rest}
  >
      {
        shouldShowMediaLibrarySelectionOption &&
          <Button
            secondary
            className="modal-option modal-option-left"
            onClick={onSelectFromMediaLibraryClick}
          >
            <ImageIcon />
            { selectFromMediaLibraryText }
          </Button>
      }

      <Button
        secondary
        className="modal-option modal-option-right"
        style={{
          width: shouldShowMediaLibrarySelectionOption ? '50%' : '100%'
        }}
        onClick={onUploadClick}
      >
        <CloudUploadIcon />
        { uploadFileText }
      </Button>

  </SimpleModalWithHeader> 
);

UploadOrChooseFromMediaLibraryModal.defaultProps = {
  shouldShowMediaLibrarySelectionOption: true
};

export default UploadOrChooseFromMediaLibraryModal;
